/* eslint-disable no-underscore-dangle */

export function init() {
  const enableTrustedShopsElt = document.getElementById('tsEnableTrustedShops');

  if (!enableTrustedShopsElt || enableTrustedShopsElt.innerText !== 'true') {
    return;
  }

  const trustedSidElt = document.getElementById('tsTrustedSid');
  const _tsid = trustedSidElt ? trustedSidElt.innerText : '';

  const tsUrl = 'https://widgets.trustedshops.com/';

  // eslint-disable-next-line no-undef
  window._tsConfig = {
    'sourceUrl': tsUrl,
    'yOffset': '0', /* offset from page bottom */
    'variant': 'custom_reviews', /* reviews, default, custom, custom_reviews */
    'customElementId': 'trustedBadge', /* required for variants custom and custom_reviews */
    'trustcardDirection': 'topRight', /* for custom variants: topRight, topLeft, bottomRight, bottomLeft */
    'customBadgeWidth': '60', /* for custom variants: 40 - 90 (in pixels) */
    'customBadgeHeight': '60', /* for custom variants: 40 - 90 (in pixels) */
    'disableResponsive': 'false', /* deactivate responsive behaviour */
    'disableTrustbadge': 'false', /* deactivate trustbadge */
  };

  const _ts = document.createElement('script');
  _ts.type = 'text/javascript';
  _ts.charset = 'utf-8';
  _ts.async = true;
  _ts.src = `${tsUrl}js/${_tsid}.js`;
  const __ts = document.getElementsByTagName('script')[0];
  __ts.parentNode.insertBefore(_ts, __ts);
}



// WEBPACK FOOTER //
// ./src/checkout/confirmation/trusted-shops.js